/**
 * CARTES PRODUIT — FLÈCHES DE GALERIE AU SURVOL (desktop, pointeur fin)
 * --------------------------------------------------------------------------
 * Le survol garde son comportement natif (2e visuel). Des flèches ‹ › apparaissent
 * au survol et font défiler tous les visuels de la carte : principal, 2e, puis les
 * diapositives --extra (médias 3+, rendues par product-card.liquid, plafonnées par
 * le réglage « Images max par carte »). Le clic sur l'image ouvre toujours la fiche.
 *
 * Mécanique : la carte passe en mode « browsing » (classe sur .product-card__media)
 * et seule la diapositive .is-active est visible (CSS collection-card-overrides.css).
 * En quittant la carte ou en survolant une pastille couleur → retour au natif.
 */
(function () {
  if (window.__cardDesktopGalleryInit) return;
  window.__cardDesktopGalleryInit = true;

  var mq = window.matchMedia('(min-width: 750px) and (pointer: fine)');
  var CONTAINER = '.product-card__media--swipe[data-desktop-arrows]';

  function slidesOf(container) {
    return Array.prototype.filter.call(
      container.querySelectorAll('.product-card__media-slide'),
      function (s) { return !s.hidden; }
    );
  }

  function reset(container) {
    container.classList.remove('is-browsing');
    container.__galleryIndex = 1; // le survol natif montre le 2e visuel
    container.querySelectorAll('.product-card__media-slide.is-active').forEach(function (s) {
      s.classList.remove('is-active');
    });
  }

  function show(container, index) {
    var slides = slidesOf(container);
    if (slides.length < 2) return;
    index = (index + slides.length) % slides.length;
    container.__galleryIndex = index;
    container.classList.add('is-browsing');
    slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
  }

  function makeButton(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'card-gallery-arrow card-gallery-arrow--' + dir;
    b.setAttribute('aria-label', dir === 'prev' ? 'Image précédente' : 'Image suivante');
    b.setAttribute('data-card-gallery', dir);
    b.innerHTML = dir === 'prev'
      ? '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M10 3 5 8l5 5" fill="none" stroke="currentColor" stroke-width="1.4"/></svg>'
      : '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="m6 3 5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.4"/></svg>';
    return b;
  }

  // Au 1er survol : flèches créées (si ≥ 3 visuels) + images 3+ chargées.
  function prepare(container) {
    if (!mq.matches) return;
    if (!container.__galleryReady) {
      container.__galleryReady = true;
      container.__galleryIndex = 1;
      container.appendChild(makeButton('prev'));
      container.appendChild(makeButton('next'));
      container.querySelectorAll('.product-card__media-slide--extra img[loading="lazy"]').forEach(function (img) {
        img.loading = 'eager';
      });
    }
    // le nb de visuels peut changer (coloris verrouillé) → on relit à chaque survol
    container.classList.toggle('has-gallery-arrows', slidesOf(container).length >= 3);
  }

  document.addEventListener('pointerover', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    var target = e.target;
    if (!target.closest) return;

    var container = target.closest(CONTAINER);
    if (container) prepare(container);

    // survol d'une pastille couleur : l'aperçu coloris reprend la main
    if (target.closest('[data-color-swatch-link]')) {
      var card = target.closest('product-card');
      var c = card && card.querySelector(CONTAINER);
      if (c) reset(c);
    }
  });

  document.addEventListener('pointerout', function (e) {
    var container = e.target.closest && e.target.closest(CONTAINER);
    if (!container) return;
    // on ne réinitialise qu'en quittant la zone image (les extras n'y sont visibles qu'au survol)
    if (e.relatedTarget && container.contains(e.relatedTarget)) return;
    reset(container);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-card-gallery]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var container = btn.closest(CONTAINER);
    if (!container) return;
    var step = btn.getAttribute('data-card-gallery') === 'prev' ? -1 : 1;
    show(container, (container.__galleryIndex || 0) + step);
  }, true);

  // Changement de coloris (clic pastille) : on repart du visuel natif.
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-color-swatch-link]');
    if (!link) return;
    var card = link.closest('product-card');
    var c = card && card.querySelector(CONTAINER);
    if (c) reset(c);
  });
})();
